import { Skeleton } from "@/components/ui/controls";
import styles from "./static.module.css";

/**
 * While a screen's code arrives: the top bar's place and the shape of a screen (a lede, then a
 * canvas), so the frame holds still instead of flashing a spinner.
 */
export function ScreenLoading() {
  return (
    <div className={styles.screenLoading} role="status" aria-live="polite">
      <span className="visually-hidden">Loading the screen</span>
      <div className={styles.loadingBar} aria-hidden="true" />
      <div className={styles.loadingBody} aria-hidden="true">
        <Skeleton height={40} width="min(560px, 90%)" />
        <Skeleton height={18} width="min(440px, 75%)" />
        <Skeleton height={360} />
      </div>
    </div>
  );
}
